import React from "react";
import "./enquiry.css";
// import phoneIcon from "../../assets/phone.jpg"; // Ensure this is a phone icon image
import whatsappIcon from "../../assets/img/WhatsApp_icon copy.png"; // Ensure this is a WhatsApp icon image

const EnquireNowButton = () => {
  return (
    <div className="enquire-now-container">
      <div className="icons-container">
        {/* Phone dialer link */}
        <a href="tel:+919363043009">
          {/* <img src={phoneIcon} alt="Phone" className="icon" /> */}
        </a>

        {/* WhatsApp chat link */}
        <a
          href="https://wa.me/9363043009?text=Hi%2C%20I%20am%20interested%20in%20booking%20a%20room."
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsappIcon} alt="WhatsApp" className="icon" />
        </a>
      </div>
    </div>
  );
};

export default EnquireNowButton;
